import landingPageApi from '../api/landingpages';
import { fetchCountryIfNeeded } from './CountryActions';

const MIN_LANDING_PAGE_UPDATE = 1000 * 60 * 5; // 5 minutes
const FETCH_LANDING_PAGE_TIMEOUT = 1000 * 30; // 30 seconds

function fetchLandingPageInProgress(pageId) {
  return {
    type: 'FETCH_LANDING_PAGE_IN_PROGRESS',
    timestamp: Date.now(),
    pageId,
  };
}

function fetchLandingPageSuccessful(pageId, page) {
  return {
    type: 'FETCH_LANDING_PAGE_SUCCESSFUL',
    pageId,
    page,
    timestamp: Date.now(),
  };
}

function fetchLandingPageFailed(pageId, reason) {
  return {
    type: 'FETCH_LANDING_PAGE_FAILED',
    reason,
    pageId,
    timestamp: Date.now(),
  };
}

export function fetchLandingPage(
  pageId,
  { country: countryPassed, platform },
  version = undefined,
) {
  return async (dispatch, getState) => {
    try {
      dispatch(fetchLandingPageInProgress(pageId));
      let country = countryPassed;
      if (!country) {
        country = await dispatch(fetchCountryIfNeeded());
      }

      const {
        auth: { apiUrl },
      } = getState();

      const landingPage = await landingPageApi.fetchLandingPage(
        apiUrl,
        pageId,
        { country, platform },
        version,
      );
      dispatch(fetchLandingPageSuccessful(pageId, landingPage));
      return landingPage;
    } catch (error) {
      dispatch(fetchLandingPageFailed(pageId, error));
      throw error;
    }
  };
}

function shouldFetchLandingPage(pageId, state, skipOutdatedCheck) {
  const landingPage = state.landingPages[pageId];

  if (!landingPage) {
    return true;
  }

  const { fetchingInProgressSince, lastSuccessfulFetch, didInvalidate } =
    landingPage;

  if (!fetchingInProgressSince) {
    // Should update if it was explicetely invalidated
    if (didInvalidate) {
      return true;
    }

    // Should update if data is too old
    if (
      !skipOutdatedCheck &&
      (!lastSuccessfulFetch ||
        Date.now() - lastSuccessfulFetch > MIN_LANDING_PAGE_UPDATE)
    ) {
      return true;
    }
  } else if (
    fetchingInProgressSince &&
    Date.now() - fetchingInProgressSince > FETCH_LANDING_PAGE_TIMEOUT
  ) {
    // Ensure we cannot get stuck in fetchingInProgressSince=true state.
    return true;
  }

  return false;
}

export function fetchLandingPageIfNeeded(
  pageId,
  { country, platform } = {},
  version = undefined,
) {
  return (dispatch, getState) => {
    const state = getState();
    if (shouldFetchLandingPage(pageId, state)) {
      return dispatch(fetchLandingPage(pageId, { country, platform }, version));
    }
    return Promise.resolve(state.landingPages[pageId]);
  };
}

export function invalidateLandingPages() {
  return {
    type: 'INVALIDATE_LANDING_PAGES',
    timestamp: Date.now(),
  };
}
